export default "__VITE_ASSET__CYJXKZfv__"